export const ENVIRONMENT = import.meta.env.VITE_ENV;
export const PRODUCTION = "production";
export const STAGING = "staging";
export const isProductionOrStaging = () =>
  [PRODUCTION, STAGING].includes(ENVIRONMENT);
